// extracted by mini-css-extract-plugin
export default {"root":"wxQrCode_root__Boroo","wxQrCode":"wxQrCode_wxQrCode__LM3R6"};